export const conversationsTopicName = (userId?: string) => userId ? `v2.users.${userId}.conversations` : undefined;
export const conversationsTypingTopicName = (userId?: string) => userId ? `v2.users.${userId}.conversations.inbound.typing.event` : undefined;
